interface TextConstant {
  DEFAULT: string;
  SCENARIO_B: string;
}

interface TrustPilotConstant {
  TITLE: string;
}

type Fonts = {
  [key: string]: string;
};

export class Constants {
  static readonly CTA_TEXT: {
    readonly HERO: TextConstant;
    readonly CARDS: TextConstant;
    readonly SUMMARY: TextConstant;
    readonly FINAL: TextConstant;
  } = {
    HERO: {
      DEFAULT: 'Jetzt Preis berechnen',
      SCENARIO_B: 'Jetzt Service entdecken'
    },
    CARDS: {
      DEFAULT: 'Jetzt Preis berechnen',
      SCENARIO_B: 'Angebot erstellen'
    },
    SUMMARY: {
      DEFAULT: 'Preis online berechnen',
      SCENARIO_B: 'Service buchen'
    },
    FINAL: { DEFAULT: 'Preisrechner starten', SCENARIO_B: 'Los gehts' }
  };

  static readonly MESSAGE: {
    readonly TRUST_PILOT: TrustPilotConstant;
  } = {
    TRUST_PILOT: {
      TITLE: 'Unsere Kunden sind überzeugt'
    }
  };

  static readonly FONT: Fonts = {
    UNIVERS_LT_PRO: 'Univers LT Pro'
  };
}
